<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<section class="report-section" [class.is-360]="is360" [class.first]="isFirst" [id]="section?.uid">
  <ptl-resource-preview [previewContent]="section?.dynamicContent" [includeSelfFeedback]="includeSelfFeedback" [learner]="learner">
  </ptl-resource-preview>
</section>
